module.exports = __webpack_public_path__ + "static/p2-2b8b5a18a994936825f0b8b65486577c.png";